// extracted by mini-css-extract-plugin
export default {"switch":"toggle_switch__trxsE","slider":"toggle_slider__bDl3K","s":"toggle_s__xBT-F","l":"toggle_l__nhg1b","input":"toggle_input__BYz5c","adaptive":"toggle_adaptive__iruht"};